import React, { useEffect, useState } from 'react';

// Add more slides here; with two or more they cross-fade automatically.
export const LOGIN_SHOWCASE_SLIDES = [
  {
    src: './img/julian_5.jpg',
    alt: 'BonusClub app on a phone, suggesting the next follow-up email',
    position: 'center 25%',
  },
];

const ROTATE_MS = 6000;

function LoginShowcase({ slides = LOGIN_SHOWCASE_SLIDES }) {
  const [active, setActive] = useState(0);

  useEffect(() => {
    if (slides.length < 2) return undefined;
    const id = setInterval(() => setActive((i) => (i + 1) % slides.length), ROTATE_MS);
    return () => clearInterval(id);
  }, [slides.length]);

  return (
    <div className="login-showcase">
      {slides.map((slide, i) => (
        <img
          key={slide.src}
          className={`login-showcase-img ${i === active ? 'is-active' : ''}`}
          src={slide.src}
          alt={i === active ? slide.alt : ''}
          style={{ objectPosition: slide.position || 'center' }}
          loading={i === 0 ? 'eager' : 'lazy'}
        />
      ))}
      <div className="login-showcase-fade" aria-hidden="true" />

      {slides.length > 1 && (
        <div className="login-showcase-dots">
          {slides.map((slide, i) => (
            <button
              key={slide.src}
              type="button"
              className={i === active ? 'is-active' : ''}
              onClick={() => setActive(i)}
              aria-label={`Show image ${i + 1}`}
            />
          ))}
        </div>
      )}
    </div>
  );
}

export default LoginShowcase;
